import slice from "./accountsSlice";

export default slice.reducer;
